import { Component, OnInit } from "@angular/core";
import { HomeService } from ".././../../service/home.service";
import { AuthenticationService } from ".././../../service/authentication.service";
import { BannerService } from ".././../../service/banner.service";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-driver",
  templateUrl: "./driver.component.html",
  styleUrls: ["./driver.component.css"]
})
export class DriverComponent implements OnInit {
  home: any;
  users: any;
  pages: any;
  backgroundUrl: String;
  driverCount: any;
  url: any;
  constructor(
    private service: HomeService,
    private authService: AuthenticationService,
    private banner: BannerService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.url = environment.apiUrl;
    this.service.getDriverHome().subscribe(res => {
      this.home = res;
    });
    this.authService.getUserinfo().subscribe(res => {
      this.users = res;
    });
    this.banner.getDriverBanner().subscribe(res => {
      this.pages = res;
      if (this.pages.image) {
        this.backgroundUrl =
          environment.apiUrl + "/assets/banner/" + this.pages.image;
      } else {
        this.backgroundUrl =
          environment.apiUrl + "/assets/frontend/images/home/banner1.jpg";
      }
    });

    this.banner.getDriverCount().subscribe(res => {
      this.driverCount = res;
    });
  }
}
